const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const SmsTemplateQuery: any = {
    GetSmsTemplate: Backofficebff + '/v1/smstemplate/get-all-smstemplate',
};
